import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';

const componentName = "DeliveryReport";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.selectedDate.name}
                    floatingLabelText={LOOKUP.report.common.selectedDate.label + "*"}
                    hintText={LOOKUP.report.common.selectedDate.label + "*"}
                    fullWidth={true}
                    required
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <BranchSelectAutoCompleteInput
                        name={componentName + LOOKUP.report.common.branchName}
                        label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}

            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 mt-1 mb_xs p-0 pt-2">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            </div>
        </div>
    </CardSimple>
);

export default Header;
